"use client";

import React from "react";
import styled from "styled-components";

import { getColor, getBorderRadius } from "../utils";

import Flex, { FlexProps } from "../Flex";
import { BoxProps } from "../Box";
import Icon from "../Icon";
import Text from "../Text";

const buttonHeights = {
  regular: "36px",
  small: "28px",
};

type Props = {
  id?: string;
  text?: string;
  size?: "regular" | "small";
  onClick?: () => void;
  disabled?: boolean;
  styleOverrides?: FlexProps & BoxProps;
};

const Wrapper = styled(Flex).attrs<Props>(props => {
  return {
    as: "button",
    role: "",
    pl: "s",
    justifyContent: "space-between",
    alignItems: "center",
    height: buttonHeights[props.size] || buttonHeights.regular,
    overflow: "hidden",
    border: "default",
    borderRadius: getBorderRadius("default", null, props),
    flexShrink: 0,
    background: getColor(props.disabled ? "grayLighter" : "white"),
  };
})<Props>`
  cursor: pointer;
  transition: background 0.2s ease-in;
  opacity: ${props => (props.disabled ? "50%" : null)};
  &:hover {
    background: ${getColor("grayLighter")};
  }
`;

type IconWrapperProps = {
  size: string;
};
const IconWrapper = styled(Flex).attrs<IconWrapperProps>(props => {
  return {
    height: buttonHeights[props.size] || buttonHeights.regular,
    width: buttonHeights[props.size] || buttonHeights.regular,
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    padding: "4px 0",
  };
})<IconWrapperProps>``;

const DropdownButton: React.FC<Props> = props => {
  // ...rest is used for data-attrs here - try to avoid using this pattern
  const { id, text, size = "small", onClick, styleOverrides, ...rest } = props;

  return (
    <Wrapper data-testid={id} size={size} onClick={onClick} {...styleOverrides} {...rest}>
      <Text color="black" font={`ui.${size}`} truncate>
        {text || ""}
      </Text>
      <IconWrapper size={size}>
        <Icon
          iconId="navigation.chevron-down"
          size={size === "small" ? "16" : "24"}
          fill="grayDarker"
        />
      </IconWrapper>
    </Wrapper>
  );
};

export default DropdownButton;
